module.exports = __webpack_public_path__ + "do.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/do.svg
// module id = 523
// module chunks = 0